import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, Form, Modal, Button } from "@themesberg/react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { IMAGE_HOST } from "src/app/common/constants";
import { PropertyContext } from "src/app/contexts/PropertyContext";

const MediaDataInput = ({ currentProperty, showImageUpdateModal, setShowImageUpdateModal }) => {
	const [imageData, setImageData] = useState({ side_images: null, head_image: null });
	const { updatePropertyImagesFromContext, getSinglePropertyFromContext } =
		useContext(PropertyContext);

	const handleFileDelete = (image) => {
		setImageData({
			...imageData,
			side_images: [...imageData?.side_images?.filter((img) => img !== image)],
		});
	};

	const handleFileChange = (e) => {
		//if (!e?.target) return;

		console.log(e.target);

		if (e?.target?.name === "head_image") {
			setImageData({ ...imageData, head_image: e?.target?.files[0] });
		} else {
			setImageData({
				...imageData,
				side_images: [...(imageData?.side_images ?? []), ...e?.target?.files],
			});
		}
		e.target.value = "";
	};

	const handleOnSubmit = () => {
		let imageDataArray = [];
		let deleteImageDataArray = [];

		let headImageData = new FormData();

		if (typeof imageData?.head_image === "object") {
			headImageData.append("image", imageData?.head_image);
			headImageData.append("is_head_image", 1);

			imageDataArray.push(headImageData);
		}

		imageData?.side_images
			?.filter((img) => typeof img === "object")
			.map((image) => {
				let sideImageData = new FormData();
				sideImageData.append("image", image);
				sideImageData.append("is_head_image", 0);

				imageDataArray.push(sideImageData);
			});

		deleteImageDataArray = currentProperty?.images?.side_images
			?.filter((img) => imageData?.side_images.includes(img) === false)
			.map((img) => ({ image_name: img }));

		let dataObj = {};

		if (imageDataArray.length && deleteImageDataArray.length) {
			dataObj = {
				id: currentProperty?.id,
				imageData: imageDataArray,
				deletedImageData: deleteImageDataArray,
			};
		} else if (imageDataArray.length) {
			dataObj = {
				id: currentProperty?.id,
				imageData: imageDataArray,
			};
		} else if (deleteImageDataArray.length) {
			dataObj = {
				id: currentProperty?.id,
				deletedImageData: deleteImageDataArray,
			};
		}

		console.log("submit!! ", imageDataArray, deleteImageDataArray, dataObj);
		if (imageDataArray.length || deleteImageDataArray.length) {
			updatePropertyImagesFromContext(dataObj?.id, dataObj, () => {
				setShowImageUpdateModal(!showImageUpdateModal);
				getSinglePropertyFromContext(dataObj?.id);
			});
		} else {
			setShowImageUpdateModal(!showImageUpdateModal);
		}
	};

	console.log(imageData);

	useEffect(() => {
		setImageData(currentProperty?.images);
	}, [currentProperty]);

	return (
		<Modal
			centered
			size="lg"
			className="modal-tertiary"
			show={showImageUpdateModal}
			onHide={() => {}}
		>
			<Modal.Header>
				<Button
					variant="close"
					className="btn-close-dark text-dark"
					aria-label="Close"
					onClick={() => setShowImageUpdateModal(!showImageUpdateModal)}
				/>
			</Modal.Header>

			<div className="px-5 py-3">
				<center>
					<h5 className="mb-4">Add Property Images</h5>
				</center>

				{/* <Row>
				<Col md={12} className="mb-3">
					<Form.Group id="propertyVideo">
						<Form.Label>Video URL:</Form.Label>
						<Form.Control
							required
							type="text"
							name="video_link"
							value={currentProperty?.["video_link"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Enter video URL"
						/>
					</Form.Group>
				</Col>
			</Row> */}
				{imageData?.head_image && (
					<Row>
						<Col md={12} className="mb-3 text-center">
							<a
								href={
									typeof imageData?.head_image === "object"
										? URL.createObjectURL(imageData?.head_image)
										: imageData?.head_image
								}
								target="_blank"
							>
								<img
									src={
										typeof imageData?.head_image === "object"
											? URL.createObjectURL(imageData?.head_image)
											: imageData?.head_image?.includes("http")
											? imageData?.head_image
											: IMAGE_HOST + imageData?.head_image
									}
									width={100}
									alt="head_image"
								/>
							</a>
						</Col>
					</Row>
				)}
				<Row>
					<Col md={12} className="mb-3">
						<Form.Group id="mainImage">
							<Form.Label>Main Image</Form.Label>
							<Form.Control
								required
								type="file"
								name="head_image"
								onChange={(e) => handleFileChange(e)}
							/>
						</Form.Group>
					</Col>
				</Row>

				{imageData?.side_images && (
					<Row>
						<Col md={12} className="mb-3 text-center">
							{imageData?.side_images?.map((image, index) => (
								<span
									style={{
										display: "inline-block",
									}}
								>
									<a
										href={
											typeof image === "object"
												? URL.createObjectURL(image)
												: image?.includes("http")
												? image
												: IMAGE_HOST + image
										}
										target="_blank"
									>
										<img
											src={
												typeof image === "object"
													? URL.createObjectURL(image)
													: image.includes("http")
													? image
													: IMAGE_HOST + image
											}
											width={100}
											alt={"side_image_" + index}
											className="mx-2"
										/>
									</a>
									<br />
									<FontAwesomeIcon
										icon={faMinusCircle}
										style={{
											color: "red",
											marginTop: "5px",
											backgroundColor: "#fff",
										}}
										onClick={() => handleFileDelete(image)}
									/>
								</span>
							))}
						</Col>
					</Row>
				)}
				<Row>
					<Col md={12} className="mb-3">
						<Form.Group id="sideImage">
							<Form.Label>Side Images</Form.Label>
							<Form.Control
								required
								type="file"
								multiple
								name="side_images"
								onChange={(e) => handleFileChange(e)}
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row>
					<Col lg={12}>
						<div className="text-end">
							<Button
								variant="dark"
								className="m-1"
								onClick={() => handleOnSubmit()}
								disabled={imageData?.head_image === null ? true : false}
							>
								Submit
							</Button>
						</div>
					</Col>
				</Row>
			</div>
		</Modal>
	);
};

export default MediaDataInput;
